<template>
  <div class="case-references py-1 px-3">
    <template v-for="ref in refs">
      <div :key="ref.id" v-if="caseById(ref.referenced_patient_case_id)" class="mb-3 shadow-sm">
        <HistoryItem
          :item="caseById(ref.referenced_patient_case_id)"
          :activeCaseId="value"
        ></HistoryItem>
      </div>
    </template>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import HistoryItem from '@/components/Panel/Doctor/PatientHistoryItem.vue'
export default {
  components: {
    HistoryItem
  },
  props: {
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      authToken: 'auth/token',
      caseReferences: 'pcase/references',
      caseById: 'pcase/byId'
    }),
    refs () {
      return this.caseReferences(this.value)
    }
  },
  watch: {
    refs: {
      deep: true,
      immediate: true,
      handler (refs) {
        if (refs) {
          for (const ref of refs) {
            if (!this.caseById(ref.referenced_patient_case_id)) {
              this.fetchCase(ref.referenced_patient_case_id)
            }
          }
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      setError: 'alert/setError',
      setCase: 'pcase/set'
    }),
    async fetchCase (caseId) {
      try {
        const response = await this.axios.get(`api/patient-cases/${caseId}`)
        const c = response.data.data
        this.setCase(c)
      } catch (err) {
        this.setError(err)
      }
    }
  }
}
</script>
